import { Infinity, PauseCircle } from "lucide-react";
import { motion } from "framer-motion";

export default function Features() {
  return (
    <section id="features" className="py-14 bg-gradient-to-b from-white to-[#F5FAFF]">
      <div className="container-max">
        <div className="mb-8">
          <h2 className="text-3xl font-extrabold">No Internet, No Cost</h2>
          <p className="text-brand-blue/70 mt-1">Annual premium plan installation free</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4 }}
            className="card p-6"
          >
            <div className="w-12 h-12 rounded-full bg-brand-blue/10 text-brand-blue flex items-center justify-center mb-3">
              <Infinity />
            </div>
            <h3 className="text-xl font-semibold">Unlimited Free Internet</h3>
            <p className="text-sm text-brand-blue/70 mt-1">
              Truly unlimited usage with no data caps or throttling.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.1 }}
            className="card p-6"
          >
            <div className="w-12 h-12 rounded-full bg-green-500/10 text-green-600 flex items-center justify-center mb-3">
              <PauseCircle />
            </div>
            <h3 className="text-xl font-semibold">No Charges During Downtime</h3>
            <p className="text-sm text-brand-blue/70 mt-1">
              If internet is down, you aren’t charged for that period.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

